let scriptLoading: Promise<void> | null = null;
const initializedPixels = new Set<string>();

function ensureFbqStub(): void {
  if (typeof window === 'undefined') return;
  if (window.fbq) return;
  const n: any = function (...args: unknown[]) {
    (n.callMethod ? n.callMethod(...args) : n.queue.push(args));
  };
  n.queue = [];
  n.loaded = true;
  n.version = '2.0';
  n.push = n;
  window.fbq = n;
  if (!window._fbq) window._fbq = n;
}

export function loadMetaPixelScript(): Promise<void> {
  if (typeof window === 'undefined') return Promise.resolve();
  if (document.getElementById('meta-pixel-fbevents')) {
    ensureFbqStub();
    return Promise.resolve();
  }
  if (scriptLoading) return scriptLoading;

  ensureFbqStub();
  scriptLoading = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.id = 'meta-pixel-fbevents';
    s.async = true;
    s.src = 'https://connect.facebook.net/en_US/fbevents.js';
    s.onload = () => resolve();
    s.onerror = () => {
      scriptLoading = null;
      reject(new Error('Falha ao carregar Meta Pixel'));
    };
    document.head.appendChild(s);
  });
  return scriptLoading;
}

export async function initMetaPixel(pixelId: string): Promise<void> {
  if (!pixelId || typeof window === 'undefined') return;
  await loadMetaPixelScript();
  ensureFbqStub();
  if (!initializedPixels.has(pixelId)) {
    // Sem grant, pixels novos podem engolir PageView (Consent Mode da Meta).
    window.fbq?.('consent', 'grant');
    window.fbq?.('init', pixelId);
    initializedPixels.add(pixelId);
  } else {
    window.fbq?.('consent', 'grant');
  }
}

export function revokeMetaPixel(): void {
  if (typeof window === 'undefined') return;
  window.fbq?.('consent', 'revoke');
}
